import { lzInitials } from "../services/LzStrings";
import { lzIsArray } from "../services/LzType";
import AddressInfoModel from "./address-info";
import MediaModel from "./media";
import SubscriptionModel from "./subscription";

export default class DealerModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.email = model.email ? model.email : '';
        this.wp = model.wp ? model.wp : '';
        this.name = model.name ? model.name : '';
        this.business_name = model.business_name ? model.business_name : '';
        this.business_address = new AddressInfoModel(model.business_address);
        this.timezone_id = model.timezone_id ? +model.timezone_id : 0;
        this.timezone_name = model.timezone_name ? model.timezone_name : '';
        this.tgd_api_connection_key = model.tgd_api_connection_key ? model.tgd_api_connection_key : '';
        this.easypost_api_key = model.easypost_api_key ? model.easypost_api_key : '';
        this.rma_label_notif_email = model.rma_label_notif_email ? model.rma_label_notif_email : '';
        this.ffl_number = model.ffl_number ? model.ffl_number : '';
        this.ffl_media = model.ffl_media ? new MediaModel(model.ffl_media) : null;
        this.ffl_media_id = model.ffl_media_id ? +model.ffl_media_id : 0;
        this.ffl_rep_email = model.ffl_rep_email ? model.ffl_rep_email : '';
        this.is_ffl_approved = !!model.is_ffl_approved;
        this.is_subscription_active = !!model.is_subscription_active;
        this.subscription_id = model.subscription_id ? +model.subscription_id : 0;
        this.subscription = model.subscription ? new SubscriptionModel(model.subscription) : null;
        this.avatar_media = model.avatar_media ? new MediaModel(model.avatar_media) : null;
        this.avatar_media_id = model.avatar_media_id ? +model.avatar_media_id : 0;
        this.is_active = typeof model.is_active === 'undefined' ? true : !!model.is_active;
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';
        this.deleted_at = model.deleted_at ? model.deleted_at : '';
    }

    get avatar_media_src() {
        return this.avatar_media?.file_preview_path;
    }

    get avatar_initials() {
        return lzInitials(this.name);
    }

    get has_rma_configs() {
        return this.tgd_api_connection_key !== '' && this.easypost_api_key !== '';
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new DealerModel(item));
        }

        return out;
    }

}
